import { useEffect, useRef, useState } from 'react';
import { SALES_WHATSAPP_LINK } from '../../utils/whatsapp';
import { ATENDABOT_PRODUCT_IMAGE } from '../../branding/assets';
import './AtendabotLP.css';

const WHATSAPP_LINK = SALES_WHATSAPP_LINK;
const SIGNUP_LINK = '/cadastro?produto=atendabot';
const LOGO = ATENDABOT_PRODUCT_IMAGE;

const Icon = ({ name, size = 22, stroke = 2, color = 'currentColor' }) => {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: stroke,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  switch (name) {
    case 'check':
      return <svg {...props}><polyline points="20 6 9 17 4 12" /></svg>;
    case 'x':
      return <svg {...props}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
    case 'arrow-right':
      return <svg {...props}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>;
    case 'clock':
      return <svg {...props}><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 16 14" /></svg>;
    case 'users':
      return <svg {...props}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
    case 'bolt':
      return <svg {...props}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>;
    case 'message':
      return <svg {...props}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>;
    case 'bag':
      return <svg {...props}><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></svg>;
    case 'calendar':
      return <svg {...props}><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>;
    case 'star':
      return <svg {...props}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>;
    case 'monitor':
      return <svg {...props}><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>;
    case 'shield':
      return <svg {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>;
    case 'chart':
      return <svg {...props}><line x1="12" y1="20" x2="12" y2="10" /><line x1="18" y1="20" x2="18" y2="4" /><line x1="6" y1="20" x2="6" y2="16" /></svg>;
    case 'phone':
      return <svg {...props}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
    case 'grid':
      return <svg {...props}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>;
    case 'card':
      return <svg {...props}><rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" /></svg>;
    case 'pulse':
      return <svg {...props}><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>;
    case 'lock':
      return <svg {...props}><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
    case 'chev-down':
      return <svg {...props}><polyline points="6 9 12 15 18 9" /></svg>;
    case 'sparkles':
      return <svg {...props}><path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z" /><path d="M19 14l.95 2.3L22.25 17.25l-2.3.95L19 20.5l-.95-2.3L15.75 17.25l2.3-.95L19 14z" /></svg>;
    case 'rocket':
      return <svg {...props}><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" /><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /></svg>;
    case 'flash':
      return <svg {...props}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>;
    case 'whatsapp':
      return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0 0 20.464 3.488" />
        </svg>
      );
    default:
      return null;
  }
};

const FAQS = [
  { q: 'Meu cliente vai perceber que está falando com uma IA?', a: 'Não. Esqueça menus numéricos e respostas robóticas. O AtendaBot treina a IA para conversas naturais e fluidas. O objetivo é que seu cliente se sinta atendido por um humano extremamente eficiente.' },
  { q: 'Preciso entender de tecnologia para configurar?', a: 'Nada disso. Você preenche um formulário contando sobre o seu restaurante, como uma entrevista. Nossa equipe cuida de tudo e você recebe a ferramenta pronta para usar em até 24 horas úteis.' },
  { q: 'O AtendaBot funciona com o meu número de WhatsApp atual?', a: 'Sim. Conectamos direto no seu número comercial atual. Sem precisar trocar de número ou avisar seus clientes de nada.' },
  { q: 'E se eu quiser atender pessoalmente um cliente específico?', a: 'Você tem controle total. Pelo painel, você pausa a IA em qualquer conversa e assume o atendimento. Quando terminar, reativa com um clique.' },
  { q: 'Tenho fornecedores e motoboys no WhatsApp. Eles também vão ser atendidos pela IA?', a: 'Não. Você cadastra uma lista de números bloqueados no painel. Para esses contatos, a IA simplesmente não é ativada. Eles ficam só para atendimento humano.' },
  { q: 'Como funciona a simulação de atendimento?', a: 'Antes de você contratar qualquer plano, nossa equipe configura um ambiente de teste com as informações do seu restaurante. Você conversa com a IA como se fosse um cliente e vê na prática como seria o atendimento. Sem compromisso e sem custo.' },
  { q: 'Meus dados e os dos meus clientes estão seguros?', a: 'Sim. Seguimos todos os protocolos da LGPD. As informações do seu negócio e dos seus clientes são criptografadas e acessíveis apenas por você.' },
  { q: 'Preciso assinar um contrato de fidelidade?', a: 'Não existe fidelidade. Nossa relação é baseada em resultados. Se por qualquer motivo o AtendaBot não fizer mais sentido, você cancela quando quiser, sem multa e sem burocracia.' },
];

const FEATURES = [
  { accent: true, icon: 'message', title: 'Atendimento com IA 24/7', text: 'A IA responde instantaneamente, conhece cada cliente pelo nome e mantém o histórico de todas as conversas. Enquanto você dorme, ela vende.' },
  { icon: 'bag', title: 'Pedidos direto no WhatsApp', text: 'O cliente escolhe os itens, adicionais e finaliza o pedido dentro da conversa. Sem apps, sem links externos, sem atrito.' },
  { icon: 'calendar', title: 'Reservas 100% automatizadas', text: 'Clientes fazem reservas pelo WhatsApp a qualquer hora. A IA confirma, gerencia e avisa sua equipe. Zero intervenção manual necessária.' },
  { icon: 'star', title: 'Coleta de feedback automática', text: 'Após cada pedido, a IA solicita avaliação de forma natural. Você recebe dados reais de satisfação para melhorar continuamente.' },
  { icon: 'monitor', title: 'Histórico completo de pedidos', text: 'Todos os pedidos registrados com filtros por data, horário, pagamento, canal e status. Exportação em CSV ou PDF para análise.' },
  { icon: 'shield', title: 'Reconhecimento de áudio', text: 'A IA entende mensagens de voz. Clientes falam o pedido e a IA processa normalmente, como se fosse um atendente humano.' },
  { icon: 'chart', title: 'Dashboard e relatórios', text: 'Acompanhe em tempo real: atendimentos, pedidos, conversão, ticket médio e origem dos clientes. Decisões baseadas em dados, não achismo.' },
  { icon: 'phone', title: 'Transbordo para humano', text: 'A qualquer momento, o atendimento pode ir para um membro da equipe, com todo o histórico da conversa já disponível.' },
  { icon: 'pulse', title: 'Áudios e imagens no atendimento', text: 'Envie e receba áudios, imagens e documentos direto pela plataforma. Tudo fica registrado no histórico do cliente, sem precisar abrir o WhatsApp.' },
];

const TARGETS = [
  'Você quer vender mais sem contratar mais pessoas ou aumentar custo fixo',
  'Você já perdeu venda porque ninguém viu a mensagem do cliente a tempo',
  'Você quer atendimento 24/7 sem pagar hora extra ou plantão',
  'Você usa Saipos ou Sischef e quer automatizar a entrada de pedidos',
  'Você quer tomar decisões com dados reais de atendimento e conversão',
  'Você quer responder cada cliente em segundos, mesmo nos horários de pico',
];

const COMPARISON = [
  { without: 'Cliente espera 5min e vai pro concorrente', with: 'IA responde em menos de 1 segundo' },
  { without: 'Equipe esquece pedido em horário de pico', with: 'Atende infinitos clientes em paralelo' },
  { without: 'Atendente falta, sai de férias, fica doente', with: 'Funciona 24/7, sem férias, sem hora extra' },
  { without: 'Não sabe quantas vendas perdeu', with: 'Dashboard com métricas em tempo real' },
];

/* ===== Reveal on scroll ===== */
const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll('.atb-lp [data-reveal]');
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
};

/* ===== Animated counter ===== */
const Counter = ({ to, prefix = '', suffix = '', duration = 1400 }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            setVal(Math.round(eased * to));
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.4 });
    io.observe(node);
    return () => io.disconnect();
  }, [to, duration]);

  return <span ref={ref}>{prefix}{val.toLocaleString('pt-BR')}{suffix}</span>;
};

const AtendabotLP = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [showStickyCta, setShowStickyCta] = useState(false);

  useReveal();

  useEffect(() => {
    const onScroll = () => setShowStickyCta(window.scrollY > 800);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'AtendaBot: Chega de perder vendas por falta de atendimento';

    const meta = (name, content, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      const created = !el;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      const prev = el.getAttribute('content');
      el.setAttribute('content', content);
      return () => {
        if (created) el.remove();
        else if (prev !== null) el.setAttribute('content', prev);
      };
    };

    const restorers = [
      meta('description', 'IA treinada no seu restaurante atende clientes 24/7 no WhatsApp. Pedidos, reservas, Pix automático e integração com Saipos e Sischef.'),
      meta('og:title', 'AtendaBot: Atendimento com IA para restaurantes', true),
      meta('og:description', 'Do primeiro contato ao pedido confirmado, sem você precisar estar presente.', true),
    ];

    let canonical = document.head.querySelector('link[rel="canonical"]');
    const createdCanonical = !canonical;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const prevHref = canonical.getAttribute('href');
    canonical.setAttribute('href', 'https://www.foodstation.app/lp/atendabot');

    return () => {
      document.title = prevTitle;
      restorers.forEach(fn => fn());
      if (createdCanonical) canonical.remove();
      else if (prevHref !== null) canonical.setAttribute('href', prevHref);
    };
  }, []);

  const toggleFaq = (i) => setOpenFaq(prev => (prev === i ? null : i));

  return (
    <div className="atb-lp">
      {/* ===== NAV ===== */}
      <nav className="atb-lp-nav">
        <div className="atb-lp-nav-inner">
          <div className="atb-lp-nav-links atb-lp-nav-links-left">
            <a href="#funcionalidades">Funcionalidades</a>
            <a href="#integracoes">Integrações</a>
            <a href="#faq">FAQ</a>
          </div>
          <a href="#top" className="atb-lp-nav-brand atb-lp-nav-brand-center">
            <img
              src={LOGO}
              alt="atendabot"
              style={{ maxHeight: '200px', maxWidth: '78%', objectFit: 'contain', transition: 'transform 0.5s, filter 0.5s' }}
            />
          </a>
          <div className="atb-lp-nav-cta-wrap">
            <a className="atb-lp-nav-cta" href={SIGNUP_LINK} target="_blank" rel="noreferrer">
              Começar 7 dias grátis
            </a>
          </div>
        </div>
      </nav>

      {/* ===== HERO ===== */}
      <header id="top" className="atb-lp-hero">
        <div className="atb-lp-hero-bg" aria-hidden="true">
          <div className="blob blob-green" />
          <div className="blob blob-white" />
          <div className="grid-overlay" />
        </div>
        <div className="atb-lp-hero-grid">
          <div className="atb-lp-hero-left">
            <h1>
              Chega de perder vendas por falta de <span className="green">atendimento</span>
            </h1>
            <p className="atb-lp-hero-sub">
              Uma IA treinada no seu restaurante atende seus clientes 24/7 no WhatsApp, do primeiro contato ao pedido confirmado, sem você precisar estar presente.
            </p>
            <ul className="atb-lp-hero-bullets">
              <li><span className="atb-lp-check"><Icon name="check" size={14} stroke={3} /></span>IA humanizada personalizada com a cara do seu restaurante</li>
              <li><span className="atb-lp-check"><Icon name="check" size={14} stroke={3} /></span>Pedidos finalizados no WhatsApp direto na cozinha</li>
              <li><span className="atb-lp-check"><Icon name="check" size={14} stroke={3} /></span>Integração com PDV como Saipos e Sischef</li>
              <li><span className="atb-lp-check"><Icon name="check" size={14} stroke={3} /></span>Reservas, feedback e histórico de pedidos inclusos</li>
            </ul>
            <div className="atb-lp-cta-row">
              <a href={SIGNUP_LINK} target="_blank" rel="noreferrer" className="atb-lp-btn atb-lp-btn-primary">
                Começar 7 dias grátis
              </a>
              <a href="#como-funciona" className="atb-lp-btn atb-lp-btn-outline">
                Ver como funciona <Icon name="arrow-right" size={16} />
              </a>
            </div>
          </div>

          <div className="atb-lp-chat" aria-hidden="true">
            <div className="atb-lp-chat-head">
              <div className="atb-lp-chat-avatar">
                <img src={LOGO} alt="" />
              </div>
              <div className="atb-lp-chat-head-info">
                <div className="name">AtendaBot</div>
                <div className="status">● online agora</div>
              </div>
              <div className="atb-lp-chat-tag">
                <Icon name="sparkles" size={12} /> IA
              </div>
            </div>
            <div className="atb-lp-chat-body">
              <div className="atb-lp-msg out">oi! queria reservar uma mesa pra hoje à noite 🍽️</div>
              <div className="atb-lp-msg in">Olá, Rafael! Que bom te ver por aqui 😊 Pra que horário e quantas pessoas?</div>
              <div className="atb-lp-msg out">20h, mesa pra 4</div>
              <div className="atb-lp-msg in">Anotado! Mesa para 4 pessoas às 20h hoje. Tem alguma preferência de ambiente? Salão interno ou terraço?</div>
              <div className="atb-lp-msg out">terraço, por favor</div>
              <div className="atb-lp-msg in">
                Reserva confirmada no <span className="pix-key">terraço às 20h ✓</span> Te esperamos hoje, Rafael! 🎉
              </div>
              <div className="atb-lp-msg-typing"><span /><span /><span /></div>
            </div>
            <div className="atb-lp-stats">
              <div>
                <div className="num"><Icon name="clock" size={18} /> 24/7</div>
                <div className="lbl">Disponibilidade</div>
              </div>
              <div>
                <div className="num"><Icon name="users" size={18} /> ∞</div>
                <div className="lbl">Conversas paralelas</div>
              </div>
              <div>
                <div className="num"><Icon name="flash" size={18} /> 1s</div>
                <div className="lbl">Tempo de resposta</div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ===== PAIN ===== */}
      <section className="atb-lp-section bg-white" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              Cada mensagem sem resposta <span className="green">é um pedido que vai pro concorrente</span>
            </h2>
            <p className="atb-lp-section-sub">
              E você nem fica sabendo. Enquanto sua equipe atende um cliente, outros 10 estão esperando.
            </p>
          </div>

          <div className="atb-lp-pain-grid">
            <div className="atb-lp-pain-card" data-reveal>
              <div className="atb-lp-pain-num">01</div>
              <div className="atb-lp-pain-head">
                <div className="atb-lp-pain-icon"><Icon name="clock" size={26} /></div>
                <h3>Tempo de resposta lento mata conversão</h3>
              </div>
              <p>Depois de 5 minutos sem resposta no WhatsApp, 80% dos clientes já abriram outro app para pedir. Você perde a venda sem nem perceber.</p>
            </div>
            <div className="atb-lp-pain-card" data-reveal>
              <div className="atb-lp-pain-num">02</div>
              <div className="atb-lp-pain-head">
                <div className="atb-lp-pain-icon"><Icon name="users" size={26} /></div>
                <h3>Depender de atendente é um risco constante</h3>
              </div>
              <p>Falta, doença, mal humor, pedido de demissão. Um funcionário de salário mínimo custa mais de R$38 mil por ano e pode te deixar na mão amanhã.</p>
            </div>
            <div className="atb-lp-pain-card" data-reveal>
              <div className="atb-lp-pain-num">03</div>
              <div className="atb-lp-pain-head">
                <div className="atb-lp-pain-icon"><Icon name="bolt" size={26} /></div>
                <h3>Picos de movimento, atendimento quebrado</h3>
              </div>
              <p>Sexta à noite, almoço de domingo. Exatamente quando mais vende, o atendimento trava. Um atendente, dezenas de clientes esperando.</p>
            </div>
          </div>

          <div className="atb-lp-data" data-reveal>
            <div>
              <h3>Por que restaurantes perdem faturamento</h3>
              <div className="sub">Principais causas relatadas por gestores do setor</div>
              <div className="atb-lp-bars">
                {[
                  { label: 'Demora no atendimento', pct: 78 },
                  { label: 'Falta de atendente disponível', pct: 65 },
                  { label: 'Erros em pedidos manuais', pct: 52 },
                  { label: 'Sem atendimento fora do horário', pct: 71 },
                ].map((b) => (
                  <div className="atb-lp-bar" key={b.label}>
                    <div className="row">
                      <span>{b.label}</span>
                      <span className="pct">{b.pct}%</span>
                    </div>
                    <div className="track">
                      <div className="fill" style={{ width: `${b.pct}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="atb-lp-stats-cards">
              <div className="atb-lp-stat-card">
                <div className="big"><Counter to={70} suffix="%" /></div>
                <div className="lbl">das empresas relatam dificuldade extrema em contratar mão de obra qualificada</div>
                <div className="src">Veja Economia, 2024</div>
              </div>
              <div className="atb-lp-stat-card">
                <div className="big">R$<Counter to={38} />k</div>
                <div className="lbl">custo anual real de um funcionário com salário mínimo, incluindo todos os encargos</div>
                <div className="src">Conta Já Contabilidade</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ANTES vs DEPOIS ===== */}
      <section className="atb-lp-section bg-off" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              A mesma operação, <span className="green">um resultado completamente diferente</span>
            </h2>
          </div>
          <div className="atb-lp-vs" data-reveal>
            <div className="atb-lp-vs-col atb-lp-vs-bad">
              <div className="atb-lp-vs-head">
                <span className="atb-lp-vs-icon bad"><Icon name="x" size={18} stroke={3} /></span>
                Sem AtendaBot
              </div>
              <ul>
                {COMPARISON.map((c, i) => (
                  <li key={i}>{c.without}</li>
                ))}
              </ul>
            </div>
            <div className="atb-lp-vs-divider">
              <span>vs</span>
            </div>
            <div className="atb-lp-vs-col atb-lp-vs-good">
              <div className="atb-lp-vs-head">
                <span className="atb-lp-vs-icon good"><Icon name="check" size={18} stroke={3} /></span>
                Com AtendaBot
              </div>
              <ul>
                {COMPARISON.map((c, i) => (
                  <li key={i}>{c.with}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOW IT WORKS ===== */}
      <section id="como-funciona" className="atb-lp-section bg-white" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              Do formulário ao<br /><span className="green">primeiro atendimento em 24h</span>
            </h2>
          </div>
          <div className="atb-lp-steps">
            {[
              { n: 1, t: 'Você preenche um formulário', d: 'Conta sobre o seu restaurante, cardápio, horários e tom de voz.' },
              { n: 2, t: 'Nossa IA aprende sobre você', d: 'Treinamos a IA com os detalhes do seu restaurante: produtos, preços, promoções e jeito de falar.' },
              { n: 3, t: 'Conectamos ao seu WhatsApp', d: 'Sem trocar de número. Integramos direto no seu WhatsApp comercial de forma simples e segura.' },
              { n: 4, t: 'Seus clientes são atendidos', d: 'A IA assume o atendimento sozinha. Você acompanha tudo pelo painel e intervém quando quiser.' },
            ].map((s) => (
              <div className="atb-lp-step" data-reveal key={s.n}>
                <div className="atb-lp-step-circle">{s.n}</div>
                <h3>{s.t}</h3>
                <p>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FEATURES ===== */}
      <section id="funcionalidades" className="atb-lp-section bg-off" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              Tudo que seu restaurante precisa <span className="green">em um único lugar</span>
            </h2>
          </div>
          <div className="atb-lp-features">
            {FEATURES.map((f, i) => (
              <div className={`atb-lp-feature${f.accent ? ' accent' : ''}`} data-reveal key={i}>
                <div className="atb-lp-feature-top">
                  <div className="atb-lp-feature-head">
                    <div className="icon"><Icon name={f.icon} size={22} /></div>
                    <h3>{f.title}</h3>
                  </div>
                  {f.soon && <span className="atb-lp-feature-soon">Em breve</span>}
                </div>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== INTEGRAÇÕES ===== */}
      <section id="integracoes" className="atb-lp-section bg-white" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-int-grid">
            <div data-reveal>
              <h2 className="atb-lp-h2">
                Conecta com o sistema <span className="green">que você já usa</span>
              </h2>
              <p className="atb-lp-section-sub" style={{ marginBottom: 0 }}>
                Hoje o AtendaBot já se integra com o <strong>Saipos</strong> e o <strong>Sischef</strong>, enviando os pedidos automaticamente para o seu PDV. Usa outro sistema? <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="atb-lp-inline-link">Fale com a gente</a> que avaliamos a integração.
              </p>
              <div className="atb-lp-int-cards">
                <div className="atb-lp-int-card">
                  <div className="logo logo-img">
                    <img src="/saipos.png" alt="Saipos" />
                  </div>
                  <div>
                    <div className="name">Saipos</div>
                    <div className="desc">Sistema de gestão para restaurantes e deliverys</div>
                  </div>
                  <span className="badge">Integrado</span>
                </div>
                <div className="atb-lp-int-card">
                  <div className="logo logo-img">
                    <img src="/sischef.svg" alt="Sischef" />
                  </div>
                  <div>
                    <div className="name">Sischef</div>
                    <div className="desc">Gestão completa para restaurantes e franquias</div>
                  </div>
                  <span className="badge">Integrado</span>
                </div>
              </div>
            </div>

            <div className="atb-lp-int-flow" data-reveal>
              <h3>Fluxo completo de um pedido</h3>
              <ol>
                {[
                  { i: 'message', t: 'Cliente envia mensagem no WhatsApp', s: 'A IA responde em menos de 1 segundo, 24h por dia' },
                  { i: 'sparkles', t: 'IA entende e personaliza a conversa', s: 'Reconhece o cliente, oferece sugestões e tira dúvidas' },
                  { i: 'bag', t: 'Pedido montado dentro da conversa', s: 'Itens, adicionais, endereço e forma de pagamento' },
                  { i: 'chart', t: 'Lançado no Saipos ou Sischef', s: 'Integração automática, sem digitação manual da equipe' },
                  { i: 'bell', t: 'Equipe da cozinha notificada', s: 'Pedido cai direto no PDV pronto para produção' },
                  { i: 'star', t: 'Feedback solicitado automaticamente', s: 'Avaliação enviada após a entrega para melhorar o atendimento' },
                ].map((x, i) => (
                  <li key={i}>
                    <div className="icon"><Icon name={x.i} size={20} /></div>
                    <div>
                      <div className="title">{x.t}</div>
                      <div className="sub">{x.s}</div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PARA QUEM É ===== */}
      <section className="atb-lp-section bg-off" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              O AtendaBot é para <span className="green">você se...</span>
            </h2>
          </div>
          <div className="atb-lp-target">
            {TARGETS.map((t, i) => (
              <div className="atb-lp-target-card" data-reveal key={i}>
                <span className="check"><Icon name="check" size={14} stroke={3} /></span>
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== VÍDEO ÚNICO ===== */}
      <section className="atb-lp-section bg-white" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              Entenda o conceito <span className="green">em menos de 1 minuto</span>
            </h2>
            <p className="atb-lp-section-sub" style={{ margin: '0 auto 32px' }}>
              Uma explicação didática e visual de como a IA transforma o atendimento e aumenta seu faturamento.
            </p>
          </div>
          <div className="atb-lp-video-single" data-reveal>
            <div className="atb-lp-video-frame">
              <iframe
                src="https://www.youtube.com/embed/yK1aKmU9vb0"
                title="AtendaBot: Conceito completo"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== SIMULAÇÃO / CTA CENTRAL ===== */}
      <section className="atb-lp-section atb-lp-sim bg-navy">
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <span className="atb-lp-tag">Antes de qualquer compromisso</span>
            <h2 className="atb-lp-h2">
              Veja como a IA atenderia <span className="em">seu</span> cliente
            </h2>
            <p className="atb-lp-sim-lead">
              Antes de assinar qualquer plano, você pode simular como seria o atendimento com a IA configurada para o seu restaurante. 
            </p>
            
          </div>

          <div className="atb-lp-sim-chat" data-reveal>
            <div className="head">
              <div className="icon"><img src={LOGO} alt="AtendaBot" /></div>
              <div>
                <div className="title">Simulação de atendimento</div>
                <div className="sub">IA treinada com os dados do seu restaurante</div>
              </div>
            </div>
            <div className="body">
              <div className="atb-lp-msg out">oi, quero saber o horário de funcionamento</div>
              <div className="atb-lp-msg in">Olá! Estamos abertos de terça a domingo, das 11h30 às 23h. Segunda fechamos para descanso da equipe 😊 Posso te ajudar com mais alguma coisa?</div>
              <div className="atb-lp-msg out">tem opção vegetariana no cardápio?</div>
              <div className="atb-lp-msg in">Sim! Temos o Burguer Veggie com blend de grão-de-bico, o Bowl de Quinoa e a Pizza Primavera. Quer que eu te mande o cardápio completo?</div>
            </div>
          </div>

          <div className="atb-lp-sim-cta" data-reveal>
            <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="atb-lp-btn atb-lp-btn-primary">
              <Icon name="whatsapp" size={18} /> Falar com um especialista agora
            </a>
            <div className="atb-lp-sim-trail">Sem compromisso. Sem cartão de crédito. Só uma conversa.</div>
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section id="faq" className="atb-lp-section bg-off" style={{ paddingTop: '56px' }}>
        <div className="container">
          <div className="atb-lp-head-center" data-reveal>
            <h2 className="atb-lp-h2">
              Ainda tem <span className="green">dúvidas?</span>
            </h2>
          </div>
          <div className="atb-lp-faq-list">
            {FAQS.map((item, i) => (
              <div className={`atb-lp-faq-item${openFaq === i ? ' open' : ''}`} key={i}>
                <button
                  type="button"
                  className="atb-lp-faq-q"
                  aria-expanded={openFaq === i}
                  onClick={() => toggleFaq(i)}
                >
                  <span>{item.q}</span>
                  <span className="chev"><Icon name="chev-down" size={20} /></span>
                </button>
                <div className="atb-lp-faq-a-wrap">
                  <div className="atb-lp-faq-a">{item.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="atb-lp-final">
        <div className="container">
          <div data-reveal>
            <div className="atb-lp-final-icon"><Icon name="rocket" size={36} /></div>
            <h2>Pronto para ver como a IA atenderia seus clientes?</h2>
            <p>Fale agora com um especialista, tire suas dúvidas e descubra como o AtendaBot pode transformar seu atendimento.</p>
            <a href={SIGNUP_LINK} target="_blank" rel="noreferrer" className="atb-lp-btn atb-lp-btn-final">
              Começar 7 dias grátis
            </a>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="atb-lp-footer">
        <div className="atb-lp-footer-inner">
          <div className="atb-lp-footer-brand">
            <img src={LOGO} alt="" aria-hidden="true" />
            <span>atendabot</span>
            <span className="by">by FoodStation</span>
          </div>
          <div className="atb-lp-footer-copy">© 2025 FoodStation. Todos os direitos reservados.</div>
          <div className="atb-lp-footer-lgpd">
            <span className="lock"><Icon name="lock" size={14} /></span>
            Dados protegidos pela LGPD
          </div>
        </div>
      </footer>

      {/* ===== STICKY MOBILE CTA ===== */}
      <a
        href={SIGNUP_LINK}
        target="_blank"
        rel="noreferrer"
        className={`atb-lp-sticky-cta${showStickyCta ? ' is-visible' : ''}`}
        aria-label="Começar 7 dias grátis"
      >
        <span>Começar 7 dias grátis</span>
      </a>

      {/* ===== CHAT FIN (mesmo da LP foodstation) ===== */}
    </div>
  );
};

export default AtendabotLP;
